/**
 * Keep the bag for 30 days — CLAUDE.md §9.
 *
 * Shopify's own cart cookie expires well before a month, and it is a cookie:
 * cleared by browser hygiene, lost when a phone drops the session. Someone who
 * picked a colour and a size three weeks ago should not have to do it again.
 *
 * So the bag is mirrored into localStorage on every change and put back if
 * Shopify's has gone empty inside the window. It restores only into an EMPTY
 * cart — never on top of a bag with something already in it, which would add
 * things nobody asked for.
 *
 * Sizes and channels can be retired (§2), so a line that no longer resolves is
 * dropped rather than failing the whole restore.
 */
(function () {
  var KEY = 'ts:bag';
  var SEEN = 'ts:bag:seen';
  var WINDOW_DAYS = 30;
  var MAX_AGE = WINDOW_DAYS * 24 * 60 * 60 * 1000;

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return null;
      var saved = JSON.parse(raw);
      if (!saved || !saved.at || !saved.items || !saved.items.length) return null;
      if (Date.now() - saved.at > MAX_AGE) {
        localStorage.removeItem(KEY);
        return null;
      }
      return saved;
    } catch (e) {
      return null;
    }
  }

  function write(cart) {
    try {
      if (!cart.items || !cart.items.length) {
        // An emptied bag is a decision, not a lapse. Do not restore it later.
        localStorage.removeItem(KEY);
        return;
      }
      localStorage.setItem(KEY, JSON.stringify({
        at: Date.now(),
        items: cart.items.map(function (item) {
          return { id: item.variant_id, quantity: item.quantity };
        })
      }));
    } catch (e) {}
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function restore(saved) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: saved.items })
    })
      .then(function (response) {
        if (response.ok) return response;
        // One or more lines no longer exist. Put back what still does, rather
        // than losing the whole bag to a single retired variant.
        return saved.items.reduce(function (chain, item) {
          return chain.then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: item.id, quantity: item.quantity })
            }).catch(function () {});
          });
        }, Promise.resolve());
      })
      .then(fetchCart)
      .then(function (cart) {
        write(cart);
        var count = document.querySelector('[data-manifest-count]');
        if (count) {
          count.textContent = ('0' + cart.item_count).slice(-2);
          var control = count.closest('.strip__bag');
          if (control) control.toggleAttribute('data-filled', cart.item_count > 0);
        }
        // The bag page was rendered against an empty cart, so it has to be
        // re-read to show what came back.
        if (cart.item_count > 0 && /\/cart/.test(location.pathname)) location.reload();
      })
      .catch(function () {});
  }

  /**
   * Restore only on the first load of a session.
   *
   * Emptying the bag is a decision and must stick. Removing the last line is a
   * link, not a fetch, so the next page load sees an empty cart and would
   * otherwise put the item straight back — the customer would be unable to
   * empty their own bag. An empty cart later in a session the bag was already
   * seen in is therefore taken at face value and the copy is dropped.
   */
  fetchCart().then(function (cart) {
    var firstOfSession = true;
    try {
      firstOfSession = !sessionStorage.getItem(SEEN);
      sessionStorage.setItem(SEEN, '1');
    } catch (e) {}

    if (cart.item_count > 0) {
      write(cart);
      return;
    }
    if (!firstOfSession) {
      try { localStorage.removeItem(KEY); } catch (e) {}
      return;
    }
    var saved = read();
    if (saved) restore(saved);
  });

  // Anything that changes the bag re-stamps the copy, which keeps the 30 days
  // running from the last time it was touched rather than from the first.
  ['cart:updated', 'ts:cart'].forEach(function (name) {
    document.addEventListener(name, function () {
      fetchCart().then(write).catch(function () {});
    });
  });

  var send = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = send.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      result.then(function () {
        fetchCart().then(write).catch(function () {});
      }).catch(function () {});
    }
    return result;
  };
})();
